export const SETTINGS_GET_REQUEST = 'SETTINGS_GET_REQUEST';
export const SETTINGS_GET_SUCCESS = 'SETTINGS_GET_SUCCESS';
export const SETTINGS_GET_FAILURE = 'SETTINGS_GET_FAILURE';

export const SETTINGS_UPDATE_REQUEST = 'SETTINGS_UPDATE_REQUEST';
export const SETTINGS_UPDATE_SUCCESS = 'SETTINGS_UPDATE_SUCCESS';
export const SETTINGS_UPDATE_FAILURE = 'SETTINGS_UPDATE_FAILURE';

export const SETTINGS_SET_HOURS_ERRORS = 'SETTINGS_SET_HOURS_ERRORS';
export const SETTINGS_CHANGE_DELIVERY_DATA = 'SETTINGS_CHANGE_DELIVERY_DATA';
